<template>
  <div class="UpgradeToGold">
    <div class="subscriptions-block">
      <div class="subscriptions-title">
        <div class="icon-top-1 icon-top-boost">
          <img
            class="my-sub-icon"
            src="@/assets/img/svg/boost-up-icon.svg"
          />
        </div>
        <div class="top-title-1 top-title-boost">
          <div class="boost-up-title">Boost Up</div>
          <div class="what-get-title">What you get...</div>
        </div>
      </div>
      <div class="subscriptions-content">
        <div class="row-sub-100">
          <div class="col-70-sub">
            <div class="make-test-card">
              <div class="desc-img-row">
                <div class="boost-text-bblock">
                  <div class="make-test-title">MAKE YOUR OWN TEST</div>
                  <div class="make-list-block">
                    <ul>
                      <li>Make unlimited Number of Tests</li>
                      <li>Customize the syllabus as per your choice</li>
                      <li>Choose your target exam and pattern</li>
                      <li>Decide the difficulty level of the test required</li>
                      <li>
                        Get customized Reports highlighting areas of possible
                        improvement
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="boost-icon-img">
                  <img
                    class="boost-sub-icon"
                    src="@/assets/img/svg/light-icon.png"
                  />
                </div>
              </div>
              <div class="desc-img-row desc-img-row-rev ">
                <div class="boost-icon-img">
                  <img
                    class="boost-sub-icon brain-icon-left"
                    src="@/assets/img/svg/practise-section.png"
                  />
                </div>
                <div class="boost-text-bblock">
                  <div class="make-test-title">PRACTICE SESSIONS</div>
                  <div class="make-list-block">
                    <ul>
                      <li>
                        Adaptive Practice Sessions: Difficulty of questions change based on your performance
                      </li>
                      <li>
                        Bookmark any question you like and retry the bookmarked
                        questions later
                      </li>
                      <li>
                        Retry Previous Year's Questions in Chapterwise form
                      </li>
                      <li>
                        Chapterwise reattempting of questions answered in Past
                        Tests
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="desc-img-row">
                <div class="boost-text-bblock">
                  <div class="make-test-title">CUSTOMIZED ASSIGNMENTS</div>
                  <div class="make-list-block">
                    <ul>
                      <li>
                        Everytime you answer a test our AI based software
                        analyzes your <br />
                        performance, identifies your weak areas and generates a
                        <br />
                        customized assignment for you that contains questions
                        similar to <br />
                        the ones you miss out in the tests.
                      </li>
                      <li>
                        This enables you to fill the gaps in your learning
                        highlighted by tests.
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="boost-icon-img">
                  <img
                    class="boost-sub-icon"
                    src="@/assets/img/svg/customize-assignment.png"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-30-sub right-sub-block"
            v-if="packages && packages.length"
          >
            <div>
              <video v-if="isShowUpgradeVideo" controls poster="@/assets/img/WhyUpgrade.png">
                <source :src="videoLink" type="video/mp4">
              </video>
              <iframe v-else class="add-frame"></iframe>
            </div>
            <div
              class="sub-btn-mt-auto"
              v-if="packages && packages.length"
              v-for="pkg in packages"
              :key="pkg.id"
            >
              <div
              class="subscription-btn-outer"
                v-for="(prodObj) in pkg.product_list"
                :key="prodObj.id"
                v-if="pkg.product_type == 'SUBSCRIPTION'"
              >
                <v-btn
                  type="button"
                  class="subscription-btn"
                  :class="[
                    isDisabled(prodObj)
                      ? ''
                      : prodObj.id === freeTrailId
                      ? 'free-trial-btn'
                      : 'paid-trial-btn',
                  ]"
                  color="primary"
                  @click="prodObj.id === freeTrailId ? buyNow(prodObj.id) : alertGSTCharges([prodObj])"
                  :disabled="isDisabled(prodObj)"
                >
                  {{ prodObj.name }}
                  {{ prodObj.price ? " @ ₹ " + prodObj.price : "" }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PaymentHiddenInput :order="order"/>

    <AlertBox
      :width="modalWidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapMutations, mapGetters, mapState, mapActions } from "vuex";
import constants from "@/utils/constants.js";
import VueCookies from 'vue-cookies';
import PaymentHiddenInput from "../../coordinator/subscription-details/PaymentHiddenInput.vue";

export default {
  name: "UnlockBoostUp",
  components: {
    PaymentHiddenInput
  },
  data() {
    return { 
      isDisable: false,
      videoLink:"",
      isShowUpgradeVideo:false,
      alertBoxData:{},
      status: false,
      modalWidth: null,
      cComponent: null,
      onPopUpTermsAndConditions: false,
      productObject: null,
      plan: null,
      freeTrailId: constants.BOOSTUP_PRODUCT_ID_FREE_TRIAL,
    };
  },
  props: ["packages"],
  mounted() {
    this.isShowUpgradeVideo = this.user.institute === constants.ONLINE_INSTITUTE_ID ? true : this.checkIsDefaultInstitute();
    this.videoLink = constants.UPGRADE_VIDEO_LINK;
  },
  computed: {
    ...mapState("userStore", ["user"]),
  },
  watch: {
    packages(val){
      if (val && val.length) {
        let productId = this.$route && this.$route.query && this.$route.query.productId ?this.$route.query.productId:null;
          let product = val.find(p=>p.product_type==="SUBSCRIPTION");

        if (productId && product && product.product_list && product.product_list.length) {
          let productObj = product.product_list.find(p=>p.id===parseInt(productId));
          if (productObj) {
            this.alertGSTCharges([productObj])
          }
        }
        
      }
    }
  },
  methods: {
    ...mapActions({
      getPackages: "userStore/getPackages",
      updateTransactionStatus: "userStore/updateTransactionStatus",
      createPackageOrder: "userStore/createPackageOrder",
      me: "userStore/me",
      getPriceDetails : "userStore/getPriceDetails"
    }),
    isDisabled(prodObj) {
      if(prodObj.id == this.plan){
        this.productObject = prodObj;
      }
      if(prodObj.id !=10 && prodObj.institute_purchased) {
        return true;  
      }
      else if(prodObj.id == 10 && (this.user.is_boostup_free_trail_used || prodObj.institute_purchased)) {
        return true;
      }
      else return false;
    },
    onClose(data) {
      if(data.payNow){
        this.buyNow(data.prodObj[0].id,data.couponCode,data.gstNumber);
      }
      else if(data.showTermsAndConditions && !this.onPopUpTermsAndConditions){
        this.showTermsAndConditions(data);
        this.onPopUpTermsAndConditions = true;
      }
      else if(data && this.onPopUpTermsAndConditions) {
        this.alertGSTCharges(data.prodObj)
        this.onPopUpTermsAndConditions = false;
      }
      else{
        this.status = data.status;
      }
        let productId = this.$route && this.$route.query && this.$route.query.productId ?this.$route.query.productId:null;

      if (data && !data.status && productId) {
        this.$cookies.remove('upgrade',this.COOKIE_PATH,this.COOKIE_DOMAIN);
        this.$router.push({name:'my-subscription'});
      }
    },
    showTermsAndConditions(data) {
      this.alertBoxData.showTermsAndConditions = data.showTermsAndConditions
      this.modalwidth = "500px";
      this.status = true;
      this.cComponent = "components/student/UpgradeToGold/TermsAndCondition";
      this.$forceUpdate();
    },
    alertGSTCharges(prodObj) {
      let reqData = {
        product_ids : prodObj.map((x) => x.id)
      }
      this.getPriceDetails(reqData)
      .then((response) => {
        if(response){
          this.alertBoxData = {};
          this.alertBoxData.prodObj = prodObj;
          this.alertBoxData.priceDetails = response;
          this.alertBoxData.persistent = true;
          this.modalWidth = "500px";
          this.status = true;
          this.cComponent = "components/student/UpgradeToGold/GstChargesPopUp";
        }
      })
      .catch((e) => {
        console.log(e);
      })
    },
    buyNow(productId,couponCode,gstNumber) {
      var pId = [];
      if (productId) {
        pId.push(productId);
        this.modifyResetPackageData();
      }
      if (pId && pId.length) {
        let success_redirect = window.location.href.split("?")[0];
        let failure_redirect = success_redirect;
        let reqData = {
          product_ids: pId,
          success_redirect,
          failure_redirect,
          coupon: couponCode,
          gst_number:gstNumber
        };
        this.createPackageOrder(reqData)
          .then((response) => {
            this.$root.showLoader = false;
            let expires = (moment().add(constants.BOOSTUP_PRODUCT_ID_FREE_TRIAL_EXPIRY, 'days')).format("DD-MM-YYYY");
            if(productId == 10) {
              this.$toasted.success(`Congratulations!\nYour 30-day free trial is activated successfully.\nThe free trial ends on ${expires}`, {});
              setTimeout(() => {
                this.$router.go(this. $router. currentRoute);
              }, 3000);
            }
            else
            this.generateDataForPayment(response.order);
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      } else {
        this.$toasted.error("Please add atleast one package in cart.");
      }
    },
    modifyResetPackageData() {
      this.packages.map((pkg) => {
        return (pkg.product_list = pkg.product_list.map((p) => {
          return {
            ...p,
            ...{
              description: p.desc,
              isAdded: false,
            },
          };
        }));
      });

      this.packages.sort(this.compare);
    },
    buyPackages(productId) {
      var packageIdsToBuy = [];
      this.packages.forEach((pkg) => {
        pkg.product_list.forEach((p) => {
          if (p.isAdded == true) {
            packageIdsToBuy.push(p.id);
          }
        });
      });
      if (packageIdsToBuy.length > 0) {
        let success_redirect = window.location.href.split("?")[0];
        let failure_redirect = success_redirect;
        let reqData = {
          product_ids: packageIdsToBuy,
          success_redirect,
          failure_redirect,
        };
        this.createPackageOrder(reqData)
          .then((response) => {
            this.$root.showLoader = false;
            this.generateDataForPayment(response.order);
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      } else {
        this.$toasted.error("Please add atleast one package in cart.");
      }
    },
    generateDataForPayment(order) {
      this.orderId = order.tx_id;
      let phoneNumber = this.user.phone;
      //phoneNumber = phoneNumber[1];
      let pd = {
        key: order.key,
        txnid: order.tx_id + "",
        amount: order.amount,
        firstname: this.user.name,
        email: this.user.email,
        phone: phoneNumber,
        productinfo: "" + order.productsForPurchase,
        surl: order.surl,
        furl: order.furl,
        hash: order.hash,
        mode: "dropout",
        udf1: order.udf1,
        udf2: order.udf2,
        udf3: order.udf3,
        udf5: "",
        pg_url:order.pg_url
    };
    this.order = pd;
      // this.launchBOLT(pd);
    },
    launchBOLT(pd) {
      let that = this;
      let handler = {
        responseHandler: function(BOLT) {
          that.checkTransactionStatus(BOLT);
        },
        catchException: function(BOLT) {
          that.handleBoltError(BOLT);
        },
      };
      bolt.launch(pd, handler);
    },
    handleBoltError(BOLT) {
      this.$toasted.error(BOLT.message);
    },
    checkTransactionStatus(BOLT) {
      if (BOLT.response.txnStatus == "CANCEL") {
        let postData = {
          order_id: this.orderId,
        };
        this.$cookies.remove('upgrade',this.COOKIE_PATH,this.COOKIE_DOMAIN);

        this.updateTransactionStatus(postData)
          .then((response) => {
            // this.getPackagesList();
            this.modifyResetPackageData();
            this.isAgreed = false;
            this.$toasted.success("Transaction Cancelled by User.");
          })
          .catch((err) => {
            this.$toasted.error("Error while updating transaction status.");
          });
      }
    },
  },
};
</script>
